import { withErrorBoundary } from '@nile/components';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { Button, DisplayText } from '@superops/ui-design-system';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCheckFeatureGating } from '@nile/components/src/HOC/withPlanFeatureGating';

const DefaultAINotification = ({ count, name, constant }) => {
  const tabContext = useContext(TabContext);
  const isWindowsManagementAuthorised = useCheckFeatureGating(
    'WINDOWS_MANAGEMENT'
  )?.enabled;
  const isRMMOnlyPlan =
    !useCheckFeatureGating('TICKETING')?.enabled &&
    isWindowsManagementAuthorised;
  const redirectToAIReviewQueue = () => {
    // if rmm only plan, redirect to /rmm/monica-ai/review-queue/list
    if (isRMMOnlyPlan) {
      tabContext?.openTab({
        module: 'RMM_HOME',
        url: '/rmm/monica-ai/review-queue'
      });
      return;
    }
    tabContext?.openTab({
      module: 'WORKSPACE',
      url: '/monica-ai/review-queue/list'
    });
  };

  return (
    <div className="mt-10 ai-dark-bg p10 br-5">
      <div className="mb10">
        <FormattedMessage
          id={`app.ai.notification.${constant}.message`}
          values={{ count }}
        />
      </div>
      <Button aiPlain onClick={redirectToAIReviewQueue} plain>
        <DisplayText element="p" size="large" weight="Medium">
          <FormattedMessage
            id={`app.ai.notification.${constant}.action.text`}
          />
        </DisplayText>
      </Button>
    </div>
  );
};

export default withErrorBoundary(DefaultAINotification);
